import { render, staticRenderFns } from "./AdminIndexView.vue?vue&type=template&id=6f58cc8b&scoped=true"
import script from "./AdminIndexView.vue?vue&type=script&lang=js"
export * from "./AdminIndexView.vue?vue&type=script&lang=js"
import style0 from "./AdminIndexView.vue?vue&type=style&index=0&id=6f58cc8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f58cc8b",
  null
  
)

export default component.exports